export default __webpack_public_path__ + "23e4665a427255f5eada5520c3402931.png";